import Vue from 'vue'
import Vuex from 'vuex'
import request from '@/utils/request'

// eslint-disable-next-line no-unused-vars
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null'),
    token: localStorage.getItem('token') || null,
    permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
    loading: false
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    REMOVE_TOKEN(state) {
      state.token = null
      localStorage.removeItem('token')
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
      localStorage.setItem('permissions', JSON.stringify(permissions))
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    // 用户登录
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        request.post('/auth/login', userInfo)
          .then(response => {
            const { data } = response
            commit('SET_TOKEN', data.token)
            commit('SET_USER_INFO', data.userInfo)
            commit('SET_PERMISSIONS', data.permissions)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    
    // 用户登出
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('REMOVE_TOKEN')
        commit('SET_USER_INFO', null)
        commit('SET_PERMISSIONS', [])
        resolve()
      })
    },
    
    // 获取用户信息
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        request.get('/auth/info')
          .then(response => {
            const { data } = response
            commit('SET_USER_INFO', data.userInfo)
            commit('SET_PERMISSIONS', data.permissions)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    hasPermission: state => permission => {
      return state.permissions.includes(permission)
    }
  }
})